import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

const { t } = i18n.global

export const OrderPages = {
  list: 'ListOrder',
  add: 'AddOrder',
  edit: 'EditOrder',
}

const title = t('navigation.orders')
const path = '/orders'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: OrderPages.add,
  component: () => import('@/pages/mainPageWithRoute/order/AddOrderPage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: OrderPages.edit,
  component: () => import('@/pages/mainPageWithRoute/order/EditOrderPage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: OrderPages.list,
  component: () => import('@/pages/mainPageWithRoute/order/ListOrderPage.vue'),
  meta: { title, requiresAuth: true },
}

export const Orders: RouteRecordRaw = {
  path,
  name: 'Orders',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
